import React from 'react';
import { createRoot } from 'react-dom/client';

import '@/index.css';
import App from '@/App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
